import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  CxDatePipe,
  I18nModule,
  provideConfig,
  provideDefaultConfigFactory,
  UrlModule
} from '@spartacus/core'
import { OrderModule } from '@spartacus/order'
import { OrderAdapter, OrderHistoryAdapter } from '@spartacus/order/core'
import { OrderRootModule } from '@spartacus/order/root'
import { TableModule } from '@spartacus/storefront'
import { EbGenericScrollModule } from '../../components/generic-scroll/eb-generic-scroll.module'
import { EbAuthGuard } from '../auth/guards/eb-auth.guard'
import { EbOrderDetailDocumentsComponent } from './components/eb-order-detail-documents/eb-order-detail-documents.component'
import { EbOrderDetailItemsComponent } from './components/eb-order-detail-items/eb-order-detail-items.component'
import { EbOrderDetailOverviewComponent } from './components/eb-order-detail-overview/eb-order-detail-overview.component'
import { EbOrderDetailTotalComponent } from './components/eb-order-detail-total/eb-order-detail-total.component'
import { ebOrderHistoryDocumentsTableConfigFactory } from './components/order-history/eb-order-history-documents-table-config'
import { EbOrderHistoryDocumentsTableDocumentCategoryComponent } from './components/order-history/eb-order-history-documents-table-document-category.component'
import { EbOrderHistoryDocumentsTableDownloadButtonComponent } from './components/order-history/eb-order-history-documents-table-download-button.component'
import { EbOrderHistoryDocumentsTableFileNameComponent } from './components/order-history/eb-order-history-documents-table-file-name.component'
import { ebOrderHistoryTableConfigFactory } from './components/order-history/eb-order-history-table-config'
import { EbOrderHistoryTableLinkComponent } from './components/order-history/eb-order-history-table-link.component'
import { EbOrderHistoryTableTranslationComponent } from './components/order-history/eb-order-history-table-translation.component'
import { EbOrderHistoryComponent } from './components/order-history/eb-order-history.component'
import {EbOccOrderHistoryAdapter} from "./services/connectors/eb-occ-order-history.adapter";
import { EbOrderAdapter } from './services/connectors/eb-order.adapter'
import { EbOrderHistoryService } from './services/facades/eb-order-history.service'

@NgModule({
  imports: [
    I18nModule,
    CommonModule,
    EbGenericScrollModule,
    TableModule,
    UrlModule,
    RouterModule,
    OrderRootModule,
    OrderModule
  ],
  declarations: [
    EbOrderHistoryComponent,
    EbOrderHistoryTableLinkComponent,
    EbOrderHistoryTableTranslationComponent,
    EbOrderHistoryDocumentsTableDownloadButtonComponent,
    EbOrderHistoryDocumentsTableDocumentCategoryComponent,
    EbOrderHistoryDocumentsTableFileNameComponent
  ],
  providers: [
    CxDatePipe,
    provideConfig({
      cmsComponents: {
        AccountOrderHistoryComponent: {
          component: EbOrderHistoryComponent,
          guards: [EbAuthGuard]
        },
        OrderDetailOverviewComponent: {
          component: EbOrderDetailOverviewComponent,
          guards: [EbAuthGuard]
        },
        OrderDetailItemsComponent: {
          component: EbOrderDetailItemsComponent,
          guards: [EbAuthGuard]
        },
        OrderDetailTotalsComponent: {
          component: EbOrderDetailTotalComponent,
          guards: [EbAuthGuard]
        },
        OrderDetailDocumentsComponent: {
          component: EbOrderDetailDocumentsComponent
        }
      }
    }),
    EbOrderHistoryService,
    {
      provide: OrderAdapter,
      useClass: EbOrderAdapter
    },
    {
      provide: OrderHistoryAdapter,
      useClass: EbOccOrderHistoryAdapter
    },
    provideDefaultConfigFactory(ebOrderHistoryTableConfigFactory),
    provideDefaultConfigFactory(ebOrderHistoryDocumentsTableConfigFactory)
  ]
})
export class EbOrderModule {}
